import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ComponentsService } from 'src/app/components.service';
import { RetypedValidator } from '../user-man/retyped.validator';

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.css']
})
export class PasswordResetComponent implements OnInit {
    username: string;
    passwordForm: FormGroup;
    submitted: boolean = false;
    displayMessage: boolean = false;
    message: string;

    constructor(
        private service: ComponentsService,
        private fb: FormBuilder
    ) {}

    ngOnInit(): void {
        this.username = this.service.getUsersPerm().username;

        this.passwordForm = this.fb.group(
            {
                oldPassword: this.fb.control('', [Validators.required]),
                newPassword: this.fb.control('', [Validators.required]),
                confirmedPassword: this.fb.control('', [Validators.required]),
                username: this.fb.control(this.username)
            },
            {
                validators: RetypedValidator('newPassword', 'confirmedPassword')
            }
        );
    }

    checkError(controlName: string, errorName: string) {
        return this.passwordForm.controls[controlName].hasError(errorName);
    }

    fadeOutMessage() {
        if (this.displayMessage) {
            setTimeout(() => {
                this.displayMessage = false;
            }, 5000);
        }
    }

    onPwdChanged() {
        this.passwordForm = this.fb.group(
            {
                oldPassword: this.fb.control('', [Validators.required]),
                newPassword: this.fb.control('', [Validators.required]),
                confirmedPassword: this.fb.control('', [Validators.required]),
                username: this.fb.control(this.username)
            },
            {
                validators: RetypedValidator('newPassword', 'confirmedPassword')
            }
        );
    }

    onSubmit() {
        this.submitted = true;

        if (this.passwordForm.invalid) {
            return;
        }

        this.service
            .changePassword(this.passwordForm.value)
            .subscribe((data) => {
                this.displayMessage = true;
                this.message = data.message;

                this.onPwdChanged();
                this.fadeOutMessage();
            });
    }
}
